// extracted by mini-css-extract-plugin
export default {"theme__btn":"buttonTheme_theme__btn__XFXt6"};